export function getElementXPath(element: Element | null | undefined): string | undefined {
    if (!element) {
        return undefined
    }

    const parts: string[] = []
    let current: Element | null = element

    while (current) {
        const { tagName } = current
        const parentElement: Element | null = current.parentElement
        const siblings = parentElement
            ? Array.from(parentElement.children).filter((sibling) => sibling.tagName === tagName)
            : [current]
        const index = siblings.length > 1 ? `[${siblings.indexOf(current) + 1}]` : ''
        parts.unshift(`${tagName.toLowerCase()}${index}`)
        current = parentElement
    }

    return `/${parts.join('/')}`
}
